import React from 'react'

export const available = ({ gov_person_registrations }) => (
  !gov_person_registrations.some(({ details }) => (
    details
    && details.Current === 'Y'
    && details.AuthorisationStatus === 'Authorised'
  ))
)

// eslint-disable-next-line react/display-name
const registerForm = ({ first_name }) => () => (
  <fieldset>
    Register {first_name} as an authorised person.
  </fieldset>
)

const apiEndPoint = ({ gov_registration, personnel }) => (
  process.env.REACT_APP_API_HOST +
  `/api/gov-registrations/${gov_registration.gov_id}/personnel/${personnel.id}/authorised-registration`
)

export const registerAuthorised = ({ gov_registration, personnel }) => (
  available(gov_registration) ?
    {
      label: 'Register as Authorised Person',
      value: 'register_authorised_person',
      component: registerForm(personnel),
      url: apiEndPoint({ gov_registration, personnel })
    } :
    null
)



// WEBPACK FOOTER //
// ./src/personnel/details/register-authorised/index.js